module.exports = __webpack_public_path__ + "img/heart.0241c650.png";